


interface ArticleBodySectionProps {
  article: {
    content_intro?: string
    content1?: string
    content2?: string
    content3?: string
    content4?: string
    image1?: string
    image2?: string
    image3?: string
    image4?: string
    image5?: string
    image6?: string
    image7?: string
    image8?: string
  }
}

export default function ArticleBodySection({ article }: ArticleBodySectionProps) {
  const { content_intro, content1, content2, content3, content4, image1, image2, image3, image4, image5, image6, image7, image8 } = article

  const renderContentSection = (content: string, index: number) => {
    if (!content) return null

    // Split content by major sections if it contains <h2>
    const sections = content.split('<h2>').filter(section => section.trim())

    if (sections.length > 1) {
      // Multiple sections with H2
      return sections.map((section, sectionIndex) => {
        const [title, ...contentParts] = section.split('</h2>')
        const sectionContent = contentParts.join('</h2>')

        return (
          <div key={sectionIndex} style={{ marginBottom: '32px' }}>
            <h2
              style={{
                fontFamily: 'Cardo',
                fontSize: '32px',
                color: '#000000',
                fontWeight: 'normal',
                lineHeight: '1.3',
                marginBottom: '24px'
              }}
            >
              {title.trim()}
            </h2>
            <div dangerouslySetInnerHTML={{ __html: sectionContent }} />
          </div>
        )
      })
    } else {
      // Single content block
      return (
        <div style={{ marginBottom: '32px' }}>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      )
    }
  }

  const renderImagePair = (imageUrl1?: string, imageUrl2?: string, withDescriptions: boolean = false, rectangular: boolean = false) => {
    if (!imageUrl1 && !imageUrl2) return null

    const imageHeight = rectangular ? '600px' : '300px'

    const imagePair = (
      <div className="grid grid-cols-2" style={{ gap: '32px', marginBottom: '32px' }}>
        {imageUrl1 && (
          <div>
            <div className="relative" style={{ height: imageHeight }}>
              <img
                src={imageUrl1}
                alt="Article image"
                className="w-full h-full object-cover"
                style={{ position: 'absolute', top: 0, left: 0 }}
              />
            </div>
          </div>
        )}
        {imageUrl2 && (
          <div>
            <div className="relative" style={{ height: imageHeight }}>
              <img
                src={imageUrl2}
                alt="Article image"
                className="w-full h-full object-cover"
                style={{ position: 'absolute', top: 0, left: 0 }}
              />
            </div>
          </div>
        )}
      </div>
    )

    return imagePair
  }

  return (
    <section
      className="w-full flex justify-center"
      style={{
        backgroundColor: '#FFFFFF',
        paddingTop: '64px',
        paddingBottom: '64px',
        paddingLeft: '240px',
        paddingRight: '240px'
      }}
    >
      <div className="max-w-4xl w-full">
        <div
          className="prose prose-lg max-w-none"
          style={{
            fontFamily: 'Plus Jakarta Sans',
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333333'
          }}
        >
          {/* Introduction Content */}
          {content_intro && renderContentSection(content_intro, 0)}

          {/* Content Section 1 + Images 1-2 */}
          {renderImagePair(image1, image2, true, true)}
          {content1 && renderContentSection(content1, 1)}
          
          {/* Content Section 2 + Images 3-4 */}
          {renderImagePair(image3, image4, false, true)}
          {content2 && renderContentSection(content2, 2)}

          {/* Content Section 3 + Images 5-6 */}
          {renderImagePair(image5, image6, false, true)}
          {content3 && renderContentSection(content3, 3)}
          
          {/* Content Section 4 + Images 7-8 */}
          {/* {content4 && renderContentSection(content4, 4)} */}
          {renderImagePair(image7, image8, false, true)}
        </div>
      </div>

    </section>
  )
}